import request from '@/utils/request'

/** 与背景模板相同：先取临时上传凭证再 PUT 到 COS */
export { getUploadTempSignature } from '../background/api'

/** GET /ancestral/panorama/scene/list */
export function getSceneList(params) {
  return request.get('/ancestral/panorama/scene/list', params)
}

/** POST /ancestral/panorama/scene/save */
export function saveScene(data) {
  return request.post('/ancestral/panorama/scene/save', data)
}

/** POST /ancestral/panorama/scene/delete */
export function deleteScene(data) {
  return request.post('/ancestral/panorama/scene/delete', data)
}

/** GET /ancestral/panorama/hotspot/list */
export function getHotspotList(params) {
  return request.get('/ancestral/panorama/hotspot/list', params)
}

/** POST /ancestral/panorama/hotspot/save */
export function saveHotspot(data) {
  return request.post('/ancestral/panorama/hotspot/save', data)
}

/** POST /ancestral/panorama/hotspot/delete */
export function deleteHotspot(data) {
  return request.post('/ancestral/panorama/hotspot/delete', data)
}
